<script>
import lazyLoadComponent from '@router/lazyload-component'
import { ruleId } from 'vfile-message'

export default {
	page: {
		meta: [{ name: 'description', content: 'Customer Analytics' }],
	},
	components: {},
	props: {
		itemType: {
			type: String,
			required: true,
		},
		defaultValue: {
			type: Object,
			default: () => initData(),
		},
	},
	data() {
		return {
			activeTab: '1',
			// ifShow:false,
			tabList: [
				{
					title: '基本資訊',
					component: () => import('./Step1Basic'),
				}
			],
			tempRef: {}
		}
	},
	computed: {
	},
	mounted() {
		this.initModuleTab()
		this.activeTab = '1'
	},
	created() {
	},
	methods: {
		initModuleTab() {
			
		},
		tabClick() {
		},
		beforeLeaveTab() {
			// 將step1Basic 放到暫存區
			if (this.$refs.step1Basic) {
				this.tempRef = this.$refs.step1Basic
				// console.log(this.tempRef, '放入暫存')
			}
			return new Promise((resolve, reject) => {
				resolve()
			})
		}

	},
	watch: {
	}
}
</script>

<template>
	<div>
		<el-tabs v-model="activeTab" stretch class="is-no-border is-no-bg isStyleBaseLine isSecond"
			:class="$style.innerTabStyle" @tab-click="tabClick" :before-leave="beforeLeaveTab">
			<el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index + 1}`">
			</el-tab-pane>
		</el-tabs>
		<slot></slot>
		<div :class="$style.componentMargin">
			<keep-alive>
				<component :is="tabList[0].component" v-if="Number(activeTab) === 1" :item-type="itemType" ref="step1Basic"
					:default-value="defaultValue">
				</component>
				<component :is="tabList[1].component" v-if="(Number(activeTab) === 2)">
				</component>
				<component :is="tabList[2].component" v-if="(Number(activeTab) === 3)">
				</component>
			</keep-alive>
		</div>
	</div>
</template>
<style lang="scss" module>
.innerTabStyle {
	background-color: $color-body-bg;

	:global {
		.el-tabs__header {
			margin-top: -15px;
			margin-bottom: 5px;
			padding-bottom: 1px;
			box-shadow: 0 2px 5px #EFF0F1;
			margin-left: -15px;
			margin-right: -15px;

			.el-tabs__item {
				padding-left: 0;
				padding-right: 0;
				background-color: $color-body-bg !important;

				&:last-child {
					border-right: 1px solid #E5E7EB;
				}

				&.is-active {
					background-color: $color-body-bg !important;
				}
			}
		}
	}
}

.componentMargin {
	margin: 20px;
	margin-top: 0;
}

:global {
	.is-second {
		.el-tabs__item {
			font-size: 14px !important;

			&.is-active {
				font-weight: normal;
				color: $color-primary !important;
			}
		}
	}
}
</style>
